/* eslint-disable @typescript-eslint/no-explicit-any */
import { useMemo } from 'react';
import { TRegisterStateChangeListener } from '@apia/dom-store';
import { TListbox } from './ListboxContext';
import { TListboxState } from './common';

export function useShoutSelectionChange(
  onSelectionChange: TListbox['onSelectionChange'],
  registerCallback: TRegisterStateChangeListener<TListboxState>,
) {
  useMemo(
    function shoutSelectionChange() {
      registerCallback((state, previousState) => {
        if (state.selectedRows !== previousState.selectedRows) {
          onSelectionChange?.({
            focusedElement: document.querySelector<HTMLElement>(
              `#${state.id}__row__${state.focusedRow}`,
            ) as HTMLElement,
            selectedElements: state.selectedRows.map((current) => {
              return document.querySelector<HTMLElement>(
                `#${state.id}__row__${current}`,
              ) as HTMLElement;
            }),
          });
        }
      });
    },
    [onSelectionChange, registerCallback],
  );
}
